import { Container, Navbar, Dropdown, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/ev-logo.svg";
import user from "../../assets/images/user.svg";
import { GoChevronDown } from "react-icons/go";
import { Dispatch, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../config/Store";
import { reduxState } from "../../reducer/CommonReducer";
import DeleteModal from "../Common/DeleteModal/DeleteModal";
import ChangePasswordModal from "../Common/ChangePasswordModal/ChangePasswordModal";
import WebService from "../../Services/WebService";
import {
  setDataInRedux,
  USER_INFO,
  USER_LOGOUT,
} from "../../action/CommonAction";
import HelperService from "../../Services/HelperService";
import { IoClose, IoMenu } from "react-icons/io5";

const Header = () => {
  const dispatch: Dispatch<any> = useDispatch();
  const commonData: any = useSelector<RootState, reduxState>(
    (state: any) => state.commonData
  );
  const [showDeleteModal, setDeleteModal] = useState<boolean>(false);
  const [showChangePassword, setShowChangePassword] = useState<boolean>(false);
  const userInfoData: any = useSelector<RootState, any>(
    (state: any) => state.userInfoData
  );

  useEffect(() => {
    userMeCall();
  }, []);

  useEffect(() => {
    if (commonData && commonData.update_me_call) {
      dispatch(setDataInRedux({ type: USER_INFO, value: {} }));
      userMeCall();
    }
  }, [commonData]);

  const onConfirmDelete = () => {
    setDeleteModal(true);
  };

  const logOut = () => {
    localStorage.clear();
    dispatch(setDataInRedux({ type: USER_LOGOUT, value: "" }));
    window.location.href = "/login";
  };

  const onLogoutredirect = () => {
    logOut();
  };

  const onLogout = () => {
    onConfirmDelete();
  };

  const userMeCall = async () => {
    WebService.getAPI({ action: "me", id: "login_btn" })
      .then((res: any) => {
        dispatch(setDataInRedux({ type: USER_INFO, value: res.user[0] }));
      })
      .catch(() => {
        typeof window !== "undefined" && localStorage.clear();
      });
  };

  const moveToDashboard = () => {
    window.location.href = "/dashboard";
  }
  const [isActive, setIsActive] = useState(false);



  const handleToggle = () => {
    setIsActive(!isActive);

    if (!isActive) {
      document.body.classList.add("mobile-menu");
    } else {
      document.body.classList.remove("mobile-menu");
    }
  };

  // =====================================================================
  // DESKTOP SIDEBAR COLLAPSE - 25/09/2026.
  //
  // Deliberately mirrors the mobile toggle right above: a class on <body>,
  // not state threaded down through Main -> VerticalMenu. The sidebar is 529
  // lines of hand-written JSX with one <Link> per item and no props at all, so
  // a body class reaches it without touching a single route, handler or
  // element. Everything the collapsed look needs is done in style.scss off
  // `body.menu-collapsed`.
  //
  // The choice is remembered, because a sidebar that springs back open on every
  // navigation is worse than one that never collapsed.
  // =====================================================================
  const [menuCollapsed, setMenuCollapsed] = useState<boolean>(
    () => localStorage.getItem("menuCollapsed") === "1",
  );

  useEffect(() => {
    document.body.classList.toggle("menu-collapsed", menuCollapsed);
    try {
      localStorage.setItem("menuCollapsed", menuCollapsed ? "1" : "0");
    } catch (e) {
      // private mode / blocked storage - the toggle still works for this session
    }
    // the class lives on <body>, which outlives this component, so it has to be
    // cleared if the header ever unmounts (logout swaps the whole layout out)
    return () => document.body.classList.remove("menu-collapsed");
  }, [menuCollapsed]);

  const handleCollapseToggle = () => setMenuCollapsed((v) => !v);




  
  return (
    <>
      <header className="site-header">
        <DeleteModal
          isShow={showDeleteModal}
          message={"Are You sure you want to logout?"}
          close={() => {
            setDeleteModal(false);
          }}
          onDelete={() => {
            onLogoutredirect();
          }}
        />
        <ChangePasswordModal
          show={showChangePassword}
          onClose={() => setShowChangePassword(false)}
        />
        <Container fluid className="header-nav">
          <div className="d-flex justify-content-between">
            <div className="d-flex gap-3 align-items-center">
              <button className="btn btn-outline-dark mobile-menu-btn d-lg-none d-blok" onClick={handleToggle}>
                <IoMenu className="icon-menu-open" />
                <IoClose className="icon-menu-close"/>
                </button>
              {/* 25/09/2026: desktop collapse. d-none d-lg-flex is the exact
                  inverse of the mobile button's d-lg-none above, so exactly one
                  of the two is ever visible and they never fight: below lg the
                  rail slides off-canvas as before, at lg and up it narrows to an
                  icon rail. aria-expanded/aria-label because this control has no
                  text of its own. */}
              <button
                type="button"
                className="btn sidebar-collapse-btn d-none d-lg-flex"
                onClick={handleCollapseToggle}
                aria-expanded={!menuCollapsed}
                aria-controls="vertical_menu"
                title={menuCollapsed ? "Expand menu" : "Collapse menu"}
                aria-label={menuCollapsed ? "Expand menu" : "Collapse menu"}
              >
                <IoMenu />
              </button>
              <a href="javascript:void(0)" className="" onClick={moveToDashboard}>
                <img src={Logo} width={186} height={70} alt="logo" className="brand-logo" />
              </a>
            </div>
            <div className="d-flex align-items-center ms-auto gap-3">
              <Dropdown className="profile-dd">
                {/* 25/09/2026: with the email gone this control is an avatar and
                    a chevron - no text at all - so it needs an explicit
                    accessible name, and a title so the address is still one
                    hover away without being permanently on screen. */}
                <Dropdown.Toggle
                  aria-label="Account menu"
                  title={userInfoData?.user_info?.email || "Account menu"}
                >
                  <div>{ }</div>
                  {userInfoData &&
                    userInfoData?.user_info &&
                    !HelperService.isEmptyObject(userInfoData?.user_info) && (
                      // 25/09/2026: the email used to sit next to the avatar
                      // here, always on screen. It is now shown only inside the
                      // open dropdown (below), so the header stays clean and an
                      // admin address is not left on display on a shared or
                      // projected screen. Nothing is lost - one click still
                      // shows which account is signed in.
                      <div className="d-flex gap-2 align-items-center">
                        <div>
                          <img
                            src={user}
                            width={35}
                            height={35}
                            className=" rounded-circle object-fit-cover"
                            alt=""
                          />
                        </div>
                      </div>
                    )}
                  {/* <div className='d-flex gap-2'>
                                        <div><img src={user} width={35} height={35} className=" rounded-circle object-fit-cover" alt='' /></div>
                                        <div >
                                            <p className='font-14 mb-0 text-dark font-medium'>Welcome</p>
                                            <p className='font-12 mb-0 text-secondary'>randywonana123@gmail.com</p>
                                        </div>
                                    </div> */}
                  <GoChevronDown size={16} className="icon" />
                </Dropdown.Toggle>

                <Dropdown.Menu align="end">
                  {/* <Link to="/profile" className="dropdown-item">My Profile</Link> */}
                  <div className="px-3 font-12 py-2 text-nowrap"> {userInfoData?.user_info?.email}</div>
                  <Dropdown.Item className="px-3" onClick={() => setShowChangePassword(true)}>
                    Change Password
                  </Dropdown.Item>
                  <Button className=" dropdown-item px-3" onClick={() => onLogout()}>
                    Logout
                  </Button>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </Container>
      </header>
    </>
  );
};
export default Header;
